import { replyableReviewLeadSources } from '../../../../../constants'
import { Button } from '../../../../Button'
import { Tooltip } from '../../../../Tooltip'
import * as S from '../Review.styles'
import { ReviewProps } from '../Review.types'

export const ReplyReviewAction = ({
  review,
  canReplyReview,
  onReplyReview,
}: Pick<ReviewProps, 'review' | 'canReplyReview' | 'onReplyReview'>) => {
  if (!onReplyReview || review.response) return null

  const getReplyTooltipContent = () => {
    if (canReplyReview) return undefined

    if (!replyableReviewLeadSources.includes(review.source)) {
      return 'Replying is only available for Airbnb and VRBO reviews'
    }

    return 'Replying is not available for this review'
  }

  return (
    <>
      <S.ReplyActionDivider />

      <Tooltip placement="top" content={getReplyTooltipContent()}>
        <div>
          <Button.Flat
            type="button"
            disabled={!canReplyReview}
            onClick={() => onReplyReview(review)}
          >
            Reply
          </Button.Flat>
        </div>
      </Tooltip>
    </>
  )
}
